import React from "react"

import VideoPlayer from "../../../../components/Quick_Installation/Videos/video-domain-name-macOS"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'INSTAR Camera Tool macOS',
  description: 'Ihrer INSTAR Kamera einen Namen in der macOS Hosts Datei vergeben',
  image: '/images/Search/QI_SearchThumb_HowDoesAnIPCameraWork.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      Ihrer INSTAR Kamera einen Namen in der macOS Hosts Datei vergeben
    </h1>
    <VideoPlayer />
    <br />
    <br />
    <Footer
      previousTitle="Quick Installation"
      previousLink="/fr/Quick_Installation/"
      nextTitle="IP Scanner"
      nextLink="/fr/Quick_Installation/Alternative_IP_Scanner/" />
  </React.Fragment>
)